/**************************************************
 * Nombre:       Formulario_Contenido_Test
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {SchoolOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjeta_Contenido_Caps from "../../Tarjetas/Tarjeta_Contenido_Caps";
import Formulario_Contenido_Caps_Contenido from "./Formulario_Contenido_Caps_Contenido";
import Formulario_Contenido_Test_Preguntas from "./Formulario_Contenido_Test_Preguntas";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import Tarjeta_Contenido_Preguntas from "../../Tarjetas/Tarjeta_Contenido_Preguntas";

const Formulario_Contenido_Test = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'preguntas',
        nombre: 'Agregar Pregunta',
        Tarjeta: Tarjeta_Contenido_Preguntas,
        Formulario: Formulario_Contenido_Test_Preguntas
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={SchoolOutlined} nombre={'Capacitacion'} dato={'nombre'} {...props}
                                   requerido={'La capacitacion es requerida'} editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 0.5}}>
                    <Typography>Preguntas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Contenido_Test